import { OverridesStyleRules } from '@mui/material/styles/overrides';

export const tableComponentOverrides:
  | Partial<OverridesStyleRules<'root' | 'stickyHeader', 'MuiTable'>>
  | undefined = {
  root: {
    tableLayout: 'fixed',
    backgroundColor: 'transparent',
    borderCollapse: 'collapse',
  },
};
